/* eslint-disable import/prefer-default-export */
export const NAV_LINKS = [
  { title: 'Talents', href: '/' },
  { title: 'Talent Lists', href: '/candidates-lists' },
  { title: 'Jobs', href: '/jobs' },
  // { title: 'Matching', href: '/similar-jobs' },
  { title: 'NAS Dashboard', href: '/nas-dashboard' },
  { title: 'NAS Campaigns', href: '/nas-campaigns' },
  // { title: 'Meta', href: '/meta' },
  // { title: 'Job Matches', href: '/job-matches' },
];
export const NAV_HIDING_LINKS = [
  // {
  //   title: 'Profilmatcher Alerts',
  //   href: '/job-matches/origins/profilmatcher-alerts',
  // },
  // { title: 'Job Imports', href: '/jobs/imports' },
];
